import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    compilerOptions: {
      isCustomElement: (tag) => ['g-map-2', 'g-marker'].includes(tag),
    },
    props: ['el'],
    data(){
      return {
        loading: false,
        items: [],
        categories: [],
        distanceOptions: [],
        selectedCategory: '',
        selectedDistance: '',
        isDesktop: window.matchMedia('(min-width: 769px)').matches,
        mapExpanded: false,
      }
    },
    mounted(){
      this.categories = JSON.parse(this.el.getAttribute('data-categories') || '[]')
      this.distanceOptions = JSON.parse(this.el.getAttribute('data-distance-options') || '[]')
      const mq = window.matchMedia('(min-width: 769px)')
      mq.addEventListener('change', e => {
        this.isDesktop = e.matches
        this.$nextTick(() => {
          this.positionMap()
          this.sizeExpandedMap()
        })
      })
      window.addEventListener('resize', window.coolHelperFunctions.debounce(() => this.sizeExpandedMap(), 150))
      this.fetchItems()
      this.$nextTick(() => this.positionMap())
    },
    computed: {
      // Pluralized noun lives in JS (not the template text node) so WordPress
      // wptexturize() can't curl the quotes and break Vue's expression parser.
      itemNoun(){
        return this.items.length === 1 ? 'event' : 'events'
      },
    },
    watch: {
      selectedCategory(){ this.fetchItems() },
      selectedDistance(){ this.fetchItems() },
    },
    methods: {
      fetchItems(){
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: 'fetch_event_map_listing',
          category: this.selectedCategory,
          distance: this.selectedDistance,
        }, json => {
          this.loading = false
          this.items = json.items || []
        }, err => {
          this.loading = false
          console.error('Events map listing fetch failed:', err)
        })
      },
      resetFilters(){
        this.selectedCategory = ''
        this.selectedDistance = ''
        this.fetchItems()
      },
      // Desktop keeps the map in its own sticky column; mobile drops it directly
      // beneath the filter bar, above the cards. Move the whole node so the map
      // instance is never re-created.
      positionMap(){
        const layout = this.el.querySelector('.events-map-listing--layout')
        const mapEl = this.el.querySelector('.events-map-listing--map')
        const filters = this.el.querySelector('.events-map-listing--filters')
        if(!layout || !mapEl || !filters){
          return
        }
        if(this.isDesktop){
          if(mapEl.parentElement !== layout){
            layout.appendChild(mapEl)
          }
        } else if(filters.nextElementSibling !== mapEl){
          filters.after(mapEl)
        }
      },
      showOnMap(item){
        const mapEl = this.el.querySelector('g-map-2')
        if(mapEl && typeof mapEl.focusMarker === 'function' && item.lat && item.lng){
          mapEl.focusMarker(parseFloat(item.lat), parseFloat(item.lng), 16)
        }
      },
      toggleMapExpanded(){
        this.mapExpanded = !this.mapExpanded
        this.$nextTick(() => this.sizeExpandedMap())
      },
      // expanded on desktop, break the map out to the viewport edge — measure the layout's
      // left so the negative margin is exact, size to clientWidth so the scrollbar stays put
      sizeExpandedMap(){
        const layout = this.el.querySelector('.events-map-listing--layout')
        const mapEl = this.el.querySelector('.events-map-listing--map')
        if(!layout || !mapEl){
          return
        }
        if(this.mapExpanded && this.isDesktop){
          mapEl.style.width = document.documentElement.clientWidth + 'px'
          mapEl.style.marginLeft = -layout.getBoundingClientRect().left + 'px'
        } else {
          mapEl.style.width = ''
          mapEl.style.marginLeft = ''
        }
        const map = this.el.querySelector('g-map-2')
        if(map && typeof map.resize === 'function'){
          map.resize()
        }
      },
    },
  }

  function initApp(){
    const els = document.querySelectorAll('.events-map-listing--app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig, { el })
        app.mount(el)
      })
    }
  }

  initApp()
}
